import { createStore, applyMiddleware, combineReducers } from 'redux'
import { CreateJumpstateMiddleware } from 'jumpstate'
import { createBrowserHistory } from 'history'
import { routerReducer, routerMiddleware } from 'react-router-redux'
import { composeWithDevTools } from 'redux-devtools-extension/developmentOnly'
import reducers from './reducers'
import devtools from './devtools'

const composeEnhancers = composeWithDevTools({
  actionsBlacklist: ['@@redux-form', 'progress_setState'],
  stateSanitizer (state) {
    return {
      ...state,
      schemas: '<<SKIPPED>>',
      mangoXML: '<SKIPPED>>',
      mangoSchemas: '<SKIPPED>>'
    }
  },
  serialize: {
    replacer (key, value) {
      if (value instanceof window.Blob) {
        return {
          size: value.size,
          type: value.type,
          name: value.name
        }
      }
      if (key !== 'help') return value
      if (typeof value !== 'string') return value
      return value.length < 20 ? value : value.slice(0, 20) + ''
    }
  }
})

export let history
let store
let workspaceIDPrev

export default function setup (workspaceID) {
  if (!workspaceID) throw new Error('no workspaceID')
  if (history && store) {
    if (workspaceID !== workspaceIDPrev) {
      throw new Error(`cannot change workspace to ${workspaceID} from ${workspaceIDPrev}`)
    }
    return { history, store }
  }

  history = createBrowserHistory({
    basename: `/w/${workspaceID}/`
  })

  setupStore(history)

  workspaceIDPrev = workspaceID

  return { store, history }
}

export function setupStore (history) {
  store = createStore(
    combineReducers({
      ...reducers(),
      router: routerReducer
    }),
    composeEnhancers(
      applyMiddleware(
        routerMiddleware(history),
        CreateJumpstateMiddleware()
      )
    )
  )

  devtools(store)
  return store
}



// WEBPACK FOOTER //
// ./src/store.js